export default __webpack_public_path__ + "static/media/signin.299774f2.svg";